import { DictionaryFormDto, FormErrors } from "../../features/admin/Dictionaries/types";

type TranslationFunction = (key: string) => string;


export const validateRequiredLang = (formData: DictionaryFormDto, t: TranslationFunction, authenticatedLanguage: string): FormErrors => {
    const description = formData.description;
    const newErrors: FormErrors = {
        description: {}
    }
    if (authenticatedLanguage === 'es' && !description?.spanish?.trim()) {
        newErrors.description = {
            ...newErrors.description,
            spanish: t("common:form.requiredFieldForm")
        };
    }

    if (authenticatedLanguage === 'ca' && !description?.catalan?.trim()) {
        newErrors.description = {
            ...newErrors.description,
            catalan: t("common:form.requiredFieldForm")
        };
    }
    if (authenticatedLanguage === 'en' && !description?.english?.trim()) {
        newErrors.description = {
            ...newErrors.description,
            english: t("common:form.requiredFieldForm")
        };
    }

    return newErrors;
};

export const validateAllRequiredLang = (formData: DictionaryFormDto, t: TranslationFunction): FormErrors => {
    const description = formData.description;
    const newErrors: FormErrors = {
        description: {}
    };

    if (!description?.catalan?.trim()) {
        newErrors.description = { ...newErrors.description, catalan: t("common:form.requiredFieldForm") };
    }
    if (!description?.spanish?.trim()) {
        newErrors.description = { ...newErrors.description, spanish: t("common:form.requiredFieldForm") };
    }
    if (!description?.english?.trim()) {
        newErrors.description = { ...newErrors.description, english: t("common:form.requiredFieldForm") };
    }
    if (!description?.french?.trim()) {
        newErrors.description = { ...newErrors.description, french: t("common:form.requiredFieldForm") };
    }

    return newErrors;
};
